/**
 * getImpersonationHeaders — pure sessionStorage reader for the
 * `X-Impersonate-Org` header the backend honors during admin impersonation.
 *
 * Deliberately pure (reads `sessionStorage` directly, no axios/React
 * dependency) so the exact same helper spreads into both the authApiClient
 * axios request interceptor AND raw fetch/EventSource call sites (SSE
 * streams can't run through an axios interceptor). Never throws — a
 * malformed or missing entry degrades to "not impersonating" ({}).
 */
export function getImpersonationHeaders(): Record<string, string> {
  try {
    const raw = sessionStorage.getItem('impersonation');
    if (!raw) return {};
    const { orgId } = JSON.parse(raw);
    return orgId ? { 'X-Impersonate-Org': String(orgId) } : {};
  } catch {
    return {};
  }
}
